import {useEffect, useReducer, useState} from "react";
import {getAdvertiseBlockId} from "../../services/advertise";
import AdvertiseBlock from "../../components/AdvertiseBlock";
import ChunkInfiniteScroll from "../../components/InfiniteScroll/ChunkInfiniteScroll";
import Survey from "../../components/Surveys/Survey";
import {useTranslation} from "react-i18next";
import Categories from "../../components/Surveys/Categories";
import useMetaTags from "react-metatags-hook";
import trackPageView from "../../services/trackPageView";
import { v4 as uuidv4 } from 'uuid';

function initFilter() {
    return {
        byCategory: '',
    };
}
function filterReducer(state, action) {
    switch (action.type) {
        case 'updateCategory':
            return {byCategory: action.value};
        case 'reset':
            if (state.byCategory !== '') {
                return initFilter();
            }

            return state;
        default:
            return {byCategory: state.byCategory};
    }
}

export default function ActiveList({surveys, categories, pinnedSurveys}) {
    const { t } = useTranslation();
    const chunkSize = 16;
    useMetaTags({
        title: t('surveys.title'),
        description: t('app.description'),
        metas: [
            { name: 'keywords', content: t('app.keywords') }
        ],
    });
    useEffect(() => {
        trackPageView(t('surveys.title'));
    })
    const [filter, dispatch] = useReducer(filterReducer, {
        byCategory: '',
    }, initFilter);
    const [currentPage, setCurrentPage] = useState(1);
    const incrementPage = () => setCurrentPage(currentPage + 1);
    const resetPage = () => setCurrentPage(1);

    const updateCategoryFilter = (value) => {
        dispatch({type: 'updateCategory', value: value});
        resetPage();
    }
    const resetFilter = () => {
        dispatch({type: 'reset'});
        resetPage();
    }
    const surveyList = surveys.filter(item => {
        return (filter.byCategory === '' || (Array.isArray(item.categories) && item.categories.includes(filter.byCategory)));
    }).slice(0, currentPage * chunkSize);

    return (
        <>
            { !!categories.length && <Categories categories={categories} notifyChange={updateCategoryFilter} reset={resetFilter} current={filter.byCategory} />}
            <AdvertiseBlock unitId="surveys2" blockLocation="content" />
            <div className="survey-items-desktop">
                <div className="survey-items-grid"
                     data-extras-id={getAdvertiseBlockId('surveys', 'list', '238-358')}>
                    <ChunkInfiniteScroll
                        Component={Survey}
                        pinnedItems={pinnedSurveys}
                        advertise={{
                            item: <AdvertiseBlock key={uuidv4()} className="surveyItem" unitId="surveys4" blockLocation="list" />,
                            position: 6
                        }}
                        items={surveyList}
                        allCategories={categories}
                        cancel={surveyList.length < currentPage * chunkSize}
                        callback={incrementPage}
                    />
                </div>
                { !surveyList.length &&
                <div className="js-surveys-no-found">
                    <h2 className="not-found" dangerouslySetInnerHTML={{__html: t('surveys.notFound')}}>
                    </h2>
                </div>
                }
            </div>
        </>
    )
}
